export interface ResourceUsage {
    resourceId: string;
    resourceName?: string;
    resourceType: string;
    workspaceId: string;
    totalEvents: number;
    createdEvents: number;
    updatedEvents: number;
    deletedEvents: number;
    createdAt: string;
    lastActivityAt: string;
    membersInvolved: string[];
    events: string[];
}

export interface GeoLocation {
    continent: string;
    continentCode: string;
    country: string;
    countryCode: string;
    region: string;
    city: string;
    latitude: number;
    longitude: number;
    timezone: string;
    postalCode?: string;
    eventCount: number;
}

export interface UsageTimelineActor {
    avatar?: string;
    id: string;
    name: string;
}

export interface UsageTimelineEvent {
    action: string;
    actor?: UsageTimelineActor;
    eventType: string;
    id: string;
    resourceId: string;
    resourceName: string;
    resourceType: string;
    timestamp: string;
}

export interface UsageOverview {
    activeContributors: number;
    activeDays: number;
    activeGuests: number;
    activeUsers: number;
    averageEventsPerResource: number;
    collaborationChanges: number;
    commentsAdded: number;
    contributorRate: number;
    exportsCompleted: number;
    resourceTypesActive: number;
    resourcesCreated: number;
    resourcesDeleted: number;
    resourcesTouched: number;
    resourcesUpdated: number;
    totalActivityEvents: number;
    versionsCreated: number;
}

export interface WorkspaceUsage {
    averageSessionDuration: string;
    totalTimeSpent: string;
    activeUsers?: number;
    activeGuests: number;
    dailyUsage: { date: string; resourceId: string; eventCount: number }[];
    timelineEvents: UsageTimelineEvent[];
    resources: ResourceUsage[];
    geoLocations: GeoLocation[];
    overview?: UsageOverview;
    partial?: boolean;
    unavailableSources?: string[];
}

export enum UsageTimeFrame {
    WEEK = '1 Week',
    MONTH = '1 Month',
    QUARTER = '1 Quarter',
    YEAR = '1 Year',
    ALL_TIME = 'All Time',
}
